export default __webpack_public_path__ + "static/home-bg-60d7afff50ec5a62e0efaabd21cbd352.png";